<div class="report-data">
<h2 class="title font-bold">{{title}}</h2>
<p class="mb-0">{{description}}</p>
<ol class="list-group list-group-flush">
  <li class="list-group-item text-truncate" *ngFor="let item of itemList;"><strong class="font-bold">{{getKey(item?.name)|
      titlecase }}</strong>
    <span class="issue-counter position-absolute text-truncate">{{item?.number}} {{itemType}}</span></li>

</ol>
</div>
